<template>
  <div>
    <b-card class="mb-4">
      <b-row>
        <b-col cols="6">
          <p>Basic PRI&trade;</p>
        </b-col>
        <b-col class="text-right" cols="6">
          <b-avatar variant="danger" text=" "></b-avatar>
        </b-col>
      </b-row>
    </b-card>
    <div>
      <b-row>
        <b-col cols="6">
          <b-card header-tag="header" style="height: 45rem;">
            <template v-slot:header>
              <h6 class="mb-0">Advanced Algorithmic PRI&trade;</h6>
            </template>
            <b-row>
              <b-col cols="10">
                <h6>[Account Name] Configured PRI&trade;</h6>
                <p>ENTITY</p>
                <p>SANCTIONS</p>
              </b-col>
              <b-col cols="2">
                <b-avatar variant="danger" text=" "></b-avatar>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="10">
                <h6>Bribery & Corruption</h6>
                <p>HISTORIC</p>
                <p>FUTURE</p>
              </b-col>
              <b-col cols="2">
                <b-avatar variant="success" text=" "></b-avatar>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="10">
                <h6>Human Rights</h6>
                <p>HISTORIC</p>
                <p>FUTURE</p>
              </b-col>
              <b-col cols="2">
                <b-avatar variant="warning" text=" "></b-avatar>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="10">
                <h6>Labour</h6>
                <p>HISTORIC</p>
                <p>FUTURE</p>
              </b-col>
              <b-col cols="2">
                <b-avatar variant="light" text=" "></b-avatar>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="10">
                <h6>Environmental</h6>
                <p>HISTORIC</p>
                <p>FUTURE</p>
              </b-col>
              <b-col cols="2">
                <b-avatar variant="danger" text=" "></b-avatar>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col cols="6">
          <b-card header-tag="header" style="height: 45rem;">
            <template v-slot:header>
              <h6 class="mb-0">Name Analysis & Confidence Score</h6>
            </template>
            <b-row>
              <b-col cols="9">
                <p>FALSE POSITIVE PROBABILITY CALCULATOR</p>
              </b-col>
              <b-col cols="3">
                <p>COMPANY SCOPE</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <h6>Name Frequency in Country</h6>
                <br />
                <b-row>
                  <b-col cols="6">
                    <p>NEAR EXACT</p>
                    <p>PARTIAL</p>
                  </b-col>
                  <b-col cols="6">
                    <p>XXX,XXX</p>
                    <p>X,XXX,XXX</p>
                  </b-col>
                </b-row>
                <h6>Name Frequency Global</h6>
                <br />
                <b-row>
                  <b-col cols="6">
                    <p>NEAR EXACT</p>
                    <p>PARTIAL</p>
                  </b-col>
                  <b-col cols="6">
                    <p>XXX,XXX</p>
                    <p>X,XXX,XXX</p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="text-right" cols="6">
                <p>Chart</p>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="6">
                <h5>
                  <i>FALSE POSITIVE ASSESSMENT</i>
                </h5>
                <h6>
                  <i>Common Name</i>
                </h6>
              </b-col>
            </b-row>
            <br />
            <p>
              <i>Due to prevalence of name [locally] [and/or] [globally] it is probable that false positives exists within the historic risk indicator score</i>
            </p>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "OverallPredictiveRiskScoreComponent",
  data() {
    return {};
  }
};
</script>